export const getCategoryTextGenClientName = (item) => {
  if (item?.cliente?.nome && item.cliente.nome.trim()) {
    return item.cliente.nome.trim()
  }

  if (item?.brand && item.brand.trim()) {
    return item.brand.trim()
  }

  return '-'
}

export const buildCategoryTextGenQueryParams = ({ selectedClientId = '', page = 1, pageSize = 10 }) => ({
  ...(selectedClientId.length > 0 && { cliente: selectedClientId }),
  page_size: pageSize,
  page,
})
